module.exports = __webpack_public_path__ + "img/expanded_framework.c8fd6b9c.png";